import ContainerWrapper from '@/pages/layout/ContainerWrapper';
import { Button, Card, Col, Row, Space, Table, Tag, Typography } from 'antd';
import React, { useState } from 'react';
import { useGetTaxOACompletedQuery } from '../../apis/lodgeReturnAPI';
import { formatDate } from '@/utils/commonUtils';
import {
  CheckOutlined,
  CloseOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import TableTitle from '@/components/Elements/Heading/TableTitle';
import ApplicationSubHeading from '@/components/Elements/Heading/ApplicationSubHeading';

const { Title } = Typography;

const TaxDealStage = () => {
  const [dealStageFilter, setDealStageFilter] = useState<string | null>(null);
  const { data: dataList, isLoading } = useGetTaxOACompletedQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const dealStages = Array.from(
    new Set(dataList?.data?.map((item: any) => item.deal_stage_name) || []),
  ) as string[];

  const columns: any = [
    {
      title: <TableTitle>S.N</TableTitle>,
      key: 'index',
      align: 'center',
      render: (_: any, __: any, index: number) => (
        <Typography.Text strong>{index + 1}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Application ID</TableTitle>,
      dataIndex: 'hs_object_id',
      key: 'hs_object_id',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Amount</TableTitle>,
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Lender</TableTitle>,
      dataIndex: 'lender',
      key: 'lender',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Deal Name</TableTitle>,
      dataIndex: 'dealname',
      key: 'dealname',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Deal Stage</TableTitle>,
      dataIndex: 'deal_stage_name',
      key: 'deal_stage_name',
      align: 'center',
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: any) => (
        <div style={{ padding: 16, width: 250 }}>
          <Typography.Text strong>Filter by Deal Stage</Typography.Text>
          <div style={{ marginTop: 12 }}>
            {dealStages.map((stage) => (
              <Button
                key={stage}
                type={selectedKeys[0] === stage ? 'primary' : 'default'}
                block
                style={{
                  marginBottom: 8,
                  textAlign: 'left',
                  backgroundColor:
                    selectedKeys[0] === stage ? undefined : '#f5f5f5',
                }}
                onClick={() => {
                  setSelectedKeys(stage ? [stage] : []);
                  setDealStageFilter(stage);
                }}
              >
                {stage}
              </Button>
            ))}
          </div>
          <Space
            style={{
              marginTop: 12,
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Button
              icon={<CloseOutlined />}
              onClick={() => {
                clearFilters();
                setDealStageFilter(null);
                confirm();
              }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={() => confirm()}
            >
              Apply
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <FilterOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value: string, record: any) =>
        record.deal_stage_name === value,
      render: (_: any, { deal_stage_name }: { deal_stage_name: string }) => {
        const color = deal_stage_name === 'in_progress' ? 'orange' : 'green';
        return <Tag color={color}>{deal_stage_name.toUpperCase()}</Tag>;
      },
    },
    {
      title: <TableTitle>Request Date</TableTitle>,
      dataIndex: 'createdate',
      key: 'createdate',
      align: 'center',
      render: (_: any, { createdate }: { createdate: string | null }) =>
        createdate ? (
          <Typography.Text>{formatDate(createdate)}</Typography.Text>
        ) : (
          <Typography.Text>N/A</Typography.Text>
        ),
    },
    {
      title: <TableTitle>Pre-approval Expiry Date</TableTitle>,
      dataIndex: 'aip_expiry',
      key: 'aip_expiry',
      align: 'center',
      render: (_: any, { aip_expiry }: { aip_expiry: string | null }) =>
        aip_expiry ? (
          <Typography.Text>{formatDate(aip_expiry)}</Typography.Text>
        ) : (
          <Typography.Text>N/A</Typography.Text>
        ),
    },
  ];

  return (
    <>
      <ApplicationSubHeading title="Tax Deal Stage" />
      <Row>
        <Col xs={24} md={24}>
          <Card
            title="Pre-approval Applications"
            extra={
              dealStageFilter && (
                <Tag
                  closable
                  onClose={() => {
                    setDealStageFilter(null);
                  }}
                >
                  {dealStageFilter}
                </Tag>
              )
            }
          >
            <Table
              dataSource={
                dealStageFilter
                  ? dataList?.data?.filter(
                      (item: any) => item.deal_stage_name === dealStageFilter,
                    ) || []
                  : dataList?.data || []
              }
              columns={columns}
              rowKey="id"
              loading={isLoading}
              pagination={{ pageSize: 5 }}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TaxDealStage;
